import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';

export const verifyCheckoutSession = httpsCallable(functions, 'verifyCheckoutSession');
export const addPostcardsToQueue = httpsCallable(functions, 'addPostcardsToQueue');
export const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
export const createSubscriptionSession = httpsCallable(functions, 'createSubscriptionSession');
export const sendContactEmail = httpsCallable(functions, 'sendContactEmail');
export const createCustomerPortalLink = httpsCallable(functions, 'createCustomerPortalLink');
export const updateSubscription = httpsCallable(functions, 'updateSubscription');
export const cancelSubscription = httpsCallable(functions, 'cancelSubscription');
export const pauseSubscription = httpsCallable(functions, 'pauseSubscription');
export const resumeSubscription = httpsCallable(functions, 'resumeSubscription');
export const getSubscriptionDetails = httpsCallable(functions, 'getSubscriptionDetails');
export const moderateUserInput = httpsCallable(functions, 'moderateUserInput');
export const validateAddress = httpsCallable(functions, 'validateAddress');
export const generateRelationshipPostcard = httpsCallable(functions, 'generateRelationshipPostcard');
export const recordRelationshipSignal = httpsCallable(functions, 'recordRelationshipSignal');
export const saveSenderOnboarding = httpsCallable(functions, 'saveSenderOnboarding');
export const sendKnowledgeGraphDigest = httpsCallable(functions, 'sendKnowledgeGraphDigest');
export const decideGiftProposal = httpsCallable(functions, 'decideGiftProposal');
export const reportGestureOutcome = httpsCallable(functions, 'reportGestureOutcome');
export const retryGiftPurchase = httpsCallable(functions, 'retryGiftPurchase');
export const replyToAgent = httpsCallable(functions, 'replyToAgent');
// The recipient's front door (token in the link, no account).
export const getRecipientAgent = httpsCallable(functions, 'getRecipientAgent');
export const claimRecipientAgent = httpsCallable(functions, 'claimRecipientAgent');
export const setRecipientPolicy = httpsCallable(functions, 'setRecipientPolicy');
export const setRecipientHoldings = httpsCallable(functions, 'setRecipientHoldings');
export const setRecipientTaste = httpsCallable(functions, 'setRecipientTaste');
export const reactToRecipientDelivery = httpsCallable(functions, 'reactToRecipientDelivery');
// Rung 0: Google Calendar + Contacts, read on the server.
export const connectGoogleEvidence = httpsCallable(functions, 'connectGoogleEvidence', { timeout: 130000 });
export const syncGoogleEvidence = httpsCallable(functions, 'syncGoogleEvidence', { timeout: 130000 });
export const disconnectGoogleEvidence = httpsCallable(functions, 'disconnectGoogleEvidence');
// Rung 1 by email: the member's private jot address.
export const getJotAddress = httpsCallable(functions, 'getJotAddress');
export const rotateJotAddress = httpsCallable(functions, 'rotateJotAddress');
// Rung 2: the weekly question's one-tap answer.
export const answerCheckIn = httpsCallable(functions, 'answerCheckIn');
// S11 · going in together
export const setPoolingPreference = httpsCallable(functions, 'setPoolingPreference');
export const answerPoolOffer = httpsCallable(functions, 'answerPoolOffer');
export const leavePool = httpsCallable(functions, 'leavePool');
export const decideJointGift = httpsCallable(functions, 'decideJointGift');
export const reportLanding = httpsCallable(functions, 'reportLanding');
export const rateHold = httpsCallable(functions, 'rateHold');
export const getLandingScore = httpsCallable(functions, 'getLandingScore');
// S17 · the envelope (AP2 mandates)
export const getEnvelope = httpsCallable(functions, 'getEnvelope');
export const draftEnvelope = httpsCallable(functions, 'draftEnvelope');
export const signEnvelope = httpsCallable(functions, 'signEnvelope');
export const revokeEnvelope = httpsCallable(functions, 'revokeEnvelope');
export const stopEnvelopeGift = httpsCallable(functions, 'stopEnvelopeGift');
